import { ethers } from 'ethers6';
import { config } from './config';
import { CREATOR_CARD_NFT_ABI } from './creatorCardNFTABI';

const NFT_CONTRACT_ADDRESS = config.ink.creatorCardNFTAddress;
const MINT_FEE = '0.0005'; // 0.0005 ETH

export interface MintCreatorCardParams {
  tokenAddress: string;
  deployerAddress: string;
  edition?: number;
}

/**
 * Mint a creator card NFT
 */
export async function mintCreatorCard(
  provider: ethers.BrowserProvider,
  params: MintCreatorCardParams
): Promise<string> {
  try {
    const { tokenAddress, deployerAddress, edition = 1 } = params;

    // Get the signer from MetaMask
    const signer = await provider.getSigner();

    // Create contract instance with signer
    const contract = new ethers.Contract(
      NFT_CONTRACT_ADDRESS,
      CREATOR_CARD_NFT_ABI,
      signer
    );

    // Call mint function with 0.0005 ETH fee
    const mintFee = ethers.parseEther(MINT_FEE);
    
    console.log('Minting creator card...', {
      tokenAddress,
      deployerAddress,
      edition,
      mintFee: ethers.formatEther(mintFee)
    });

    const tx = await contract.mintCreatorCardNFT(
      tokenAddress,
      deployerAddress,
      edition,
      { value: mintFee }
    );

    console.log('Transaction sent:', tx.hash);

    // Wait for transaction
    const receipt = await tx.wait();
    
    console.log('Mint successful!', receipt);

    return receipt.hash;
  } catch (error: any) {
    console.error('Mint error:', error);
    // Provide user-friendly error messages
    if (error.message?.includes('already minted')) {
      throw new Error('This card has already been minted');
    }
    if (error.message?.includes('Only token deployer can mint')) {
      throw new Error('Only the token deployer can mint this card');
    }
    if (error.message?.includes('Insufficient mint fee')) {
      throw new Error('Mint fee too low. Please send exactly 0.0005 ETH');
    }
    if (error.message?.includes('rate limited')) {
      throw new Error('Network is experiencing high traffic. Please try again in a few moments.');
    }
    throw new Error(error.message || 'Failed to mint creator card');
  }
}

/**
 * Check if a token card is already minted
 */
export async function isCardMinted(
  provider: ethers.JsonRpcProvider | ethers.BrowserProvider,
  tokenAddress: string
): Promise<boolean> {
  try {
    const contract = new ethers.Contract(
      NFT_CONTRACT_ADDRESS,
      CREATOR_CARD_NFT_ABI,
      provider
    );

    const minted = await contract.tokenCardMinted(tokenAddress);
    return minted;
  } catch (error) {
    console.error('Error checking minted status:', error);
    return false;
  }
}

